import React, { FC } from 'react'
import URLSearchParams from 'url-search-params'
import { zoomConnect } from '../../api/api'
import { Integrations, IProps } from './types'
import { useHistory } from 'react-router-dom'
import { readCookie } from '../../utils/cookies'
import Calendars from '../../Components/calendar/Calendars'
import { ApiResponse } from '../../types/plann3r'

const Integration: FC<IProps> = ({ match }) => {
  const history = useHistory()

  const integrationConnected = (response: ApiResponse) => {
    if (response.success) {
      history.push('/pages')
    } else {
      alert('Authentication went wrong, please try again.')
    }
  }

  const zoom = async () => {
    const code = new URLSearchParams(window.location.search).get('code')

    if (code) {
      const integration = { authCode: code }

      integrationConnected(await zoomConnect(integration))
    } else {
      alert('Oops, something went wrong. No code was passed to Plann3r.')
    }
  }

  const integrate = () => {
    const integration = match.params.integration
    if (integration !== '' && integration !== undefined) {
      switch (integration) {
        case Integrations.ZOOM:
          zoom()
          break
        default:
          break
      }
    } else {
      alert('This is not a valid url.')
      history.push('/')
    }
  }

  integrate()

  if (!readCookie('token')) {
    return (
      <div>
        <Calendars
          nextThing={integrate}
          nextThingNewAccount={() => {
            history.push('/onboarding')
          }}
          oneIsEnough={true}
          nextThingText="Connect integration to Plann3r"
        />
      </div>
    )
  }

  return <div></div>
}

export default Integration
